<template>
  <div class="card container">
    <h1 class="title">{{pages.title.rendered}}</h1>
    <div class="content">
      <p v-html="pages.content.rendered"></p>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.card {
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
  padding: 3rem;
}
</style>
<script>
import axios from 'axios';

export default {
  data() {
    return {
      baseURL: 'http://staging2.tribeagles.org',
      slug: this.$route.params.slug,
      pages: [],
    };
  },

  async created() {
    try {
      const response = await axios.get(`${this.baseURL}/wp-json/wp/v2/pages/?slug=${this.slug}`);
      this.pages = response.data[0];
    } catch (e) {
      this.errors.push(e);
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages.vue